import React from 'react';

/**
 * LoadingSpinner - Standardized loading spinner component
 * @param {string} size - Size: 'sm', 'md', 'lg' (default: 'md')
 * @param {string} color - Color: 'primary', 'secondary', 'white' (default: 'primary')
 * @param {string} className - Additional CSS classes
 * @param {string} text - Optional loading text
 */
const LoadingSpinner = ({ 
  size = 'md', 
  color = 'primary', 
  className = '', 
  text = '',
  ...props 
}) => {
  const sizeClasses = {
    sm: 'spinner-sm',
    md: 'spinner-md',
    lg: 'spinner-lg',
  };

  const colorClasses = {
    primary: 'spinner-primary',
    secondary: 'spinner-secondary',
    white: 'spinner-white',
  };

  return (
    <div className={`loading-spinner ${sizeClasses[size]} ${colorClasses[color]} ${className}`} {...props}>
      <div className="spinner" role="status" aria-label={text || 'Loading'}>
        <span className="visually-hidden">{text || 'Loading...'}</span>
      </div>
      {text && <span className="loading-spinner-text">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;
